import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { HelpScoutBeacon } from './helpScoutBeacon'

const HelpScoutBeaconUpdater = (): null => {
  const location = useLocation()
  useEffect(() => {
    // Let Beacon know when we've changed pages
    if (window && window.Beacon) {
      HelpScoutBeacon.updateHelpScoutBeacon(location.pathname)
    }
  }, [location])
  return null
}

export default HelpScoutBeaconUpdater
